export default __webpack_public_path__ + "static/media/site.d4dcbb2c.webmanifest";